import IService from "@api/iService";
import {
    IGoal,
    IGoalCondition, IGoalGroup,
    IGoalGroupShort,
    IGoalReward,
    IRef,
    IRefReward,
    IRefShort,
    IRefTarget,
    ISearchGoal, ISearchGoalGroup
} from "@interfaces/consumer/refs";
import { PanelTableData } from "@interfaces/panel";
import {
    PatchConditionModel,
    PatchGoalModel,
    PatchRefModel,
    PatchGoalRewardModel,
    PutConditionModel,
    PutGoalModel,
    PutRefModel,
    PutGoalRewardModel,
    PutRefRewardModel,
    PatchRefRewardModel,
    SearchGoalModel,
    PutRefTargetModel,
    PatchRefTargetModel,
    PutGoalGroupModel, PatchGoalGroupModel, SearchGoalGroupModel
} from "@models/consumer/refs";
import { PanelTableDataModel } from "@models/panel";

export default class ConsumerRefService extends IService {

    getGoalGroups = async (model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<IGoalGroupShort[]>>('/api/consumer/goals/group/', model);
    }

    getGoalGroup = async (groupId: string) => {
        return await this.getApi<IGoalGroup>(`/api/consumer/goals/group/${groupId}/`);
    }

    putGoalGroup = async (group: PutGoalGroupModel) => {
        return await this.putApi<IGoalGroup>('/api/consumer/goals/group/', group);
    }

    patchGoalGroup = async (group: PatchGoalGroupModel) => {
        return await this.patchApi<IGoalGroup>('/api/consumer/goals/group/', group);
    }

    searchGoalGroup = async (name: string) => {
        return await this.postApi<ISearchGoalGroup[]>('/api/consumer/goals/group/search/', {
            name
        } as SearchGoalGroupModel);
    }

    getGoals = async (model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<IGoal[]>>('/api/consumer/goals/', model);
    }

    async getGoal(goalId: string) {
        return await this.getApi<IGoal>(`/api/consumer/goals/${goalId}/`);
    }

    searchGoal(name: string) {
        return this.postApi<ISearchGoal[]>('/api/consumer/goals/search/', {
            name
        } as SearchGoalModel)
    }

    putGoal(model: PutGoalModel) {
        return this.putApi<IGoal>('/api/consumer/goals/', model);
    }

    patchGoal(model: PatchGoalModel) {
        return this.patchApi<IGoal>('/api/consumer/goals/', model);
    }

    deleteGoal(id: string) {
        return this.deleteApi(`/api/consumer/goals/${id}/`);
    }

    getGoalConditions(goalId: string, model: PanelTableDataModel) {
        return this.postApi<PanelTableData<IGoalCondition[]>>(`/api/consumer/goals/${goalId}/condition/`, model);
    }

    getGoalCondition(goalId: string, conditionId: string) {
        return this.getApi<IGoalCondition>(`/api/consumer/goals/${goalId}/condition/${conditionId}/`);
    }

    putCondition(goalId: string, model: PutConditionModel) {
        return this.putApi<IGoalCondition>(`/api/consumer/goals/${goalId}/condition/`, model);
    }

    patchCondition(goalId: string, model: PatchConditionModel) {
        return this.patchApi<IGoalCondition>(`/api/consumer/goals/${goalId}/condition/`, model);
    }

    getGoalRewards(goalId: string, model: PanelTableDataModel) {
        return this.postApi<PanelTableData<IGoalReward[]>>(`/api/consumer/goals/${goalId}/reward/`, model);
    }

    getGoalReward(goalId: string, rewardId: string) {
        return this.getApi<IGoalReward>(`/api/consumer/goals/${goalId}/reward/${rewardId}/`);
    }

    putGoalReward(goalId: string, model: PutGoalRewardModel) {
        return this.putApi<IGoalReward>(`/api/consumer/goals/${goalId}/reward/`, model);
    }

    patchGoalReward(goalId: string, model: PatchGoalRewardModel) {
        return this.patchApi<IGoalReward>(`/api/consumer/goals/${goalId}/reward/`, model);
    }

    getRefs = async (model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<IRefShort[]>>('/api/consumer/refs/', model);
    }

    getRef(refId: string) {
        return this.getApi<IRef>(`/api/consumer/refs/${refId}/`);
    }

    putRef(model: PutRefModel) {
        return this.putApi<IRef>('/api/consumer/refs/', model);
    }

    patchRef(model: PatchRefModel) {
        return this.patchApi<IRef>('/api/consumer/refs/', model);
    }

    deleteRef(refId: string) {
        return this.deleteApi(`/api/consumer/refs/${refId}/`);
    }

    getRefRewards(refId: string, model: PanelTableDataModel) {
        return this.postApi<PanelTableData<IRefReward[]>>(`/api/consumer/refs/${refId}/reward/`, model);
    }

    getRefReward(refId: string, rewardId: string) {
        return this.getApi<IRefReward>(`/api/consumer/refs/${refId}/reward/${rewardId}/`);
    }

    putRefReward(refId: string, model: PutRefRewardModel) {
        return this.putApi<IRefReward>(`/api/consumer/refs/${refId}/reward/`, model);
    }

    patchRefReward(refId: string, model: PatchRefRewardModel) {
        return this.patchApi<IRefReward>(`/api/consumer/refs/${refId}/reward/`, model);
    }

    getRefTargets(refId: string, model: PanelTableDataModel) {
        return this.postApi<PanelTableData<IRefTarget[]>>(`/api/consumer/refs/${refId}/target/`, model);
    }

    getRefTarget(refId: string, targetId: string) {
        return this.getApi<IRefTarget>(`/api/consumer/refs/${refId}/target/${targetId}/`);
    }

    putRefTarget(refId: string, model: PutRefTargetModel) {
        return this.putApi<IRefTarget>(`/api/consumer/refs/${refId}/target/`, model);
    }

    patchRefTarget(refId: string, model: PatchRefTargetModel) {
        return this.patchApi<IRefTarget>(`/api/consumer/refs/${refId}/target/`, model);
    }
}